import { connect } from "react-redux";
import ApprovalWalletDetails from "./approvalwalletDetails";
import { bindActionCreators } from "redux";
import {viewRequest, approvalAction} from "../../../services/redux/Wallet/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
import {requesttransactionList} from "../../../services/redux/Wallet/action";

const mapStateToProps = (state) => ({
    requestById : state.Wallet.requestById,
    requestedAction : state.Wallet.requestedAction,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    requesttransactionListDetails : state.Wallet.requesttransactionlisting,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        viewRequest,
        documentUploadUrlPublic,
        approvalAction,
        requesttransactionList,
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalWalletDetails);